export interface EndpointModels {
  SERVER: string;
  UPLOAD_BACKBLAZE: string;
  DELETE_BACKBLAZE: string;
  DOWNLOAD_BACKBLAZE: string;
}
